<template>
	<div class="home">
		<h1>HT for Web</h1>
		<h2>构建先进 2D 和 3D 可视化所需要的一切</h2>
		<ht-view ref="htView" class="ht-view" :auto-invalidate="true" type="2d"></ht-view>
	</div>
</template>

<script>
export default {
	name: 'Case1',
	mounted(){
		var htView = this.$refs.htView;
		this.initHtView(htView.getDataModel(), htView.getGraphView());
	},
	methods: {
		initHtView(dataModel, graphView){
			var vueLogo = new ht.Node();
			vueLogo.setName('VUE Logo');
			vueLogo.setImage('logo-vue.png');
			vueLogo.setPosition(100, 100);                
			dataModel.add(vueLogo);
			
			var htLogo = new ht.Node();
			htLogo.setName('HT Logo');                
			htLogo.setImage('logo-ht.png');
			htLogo.setPosition(360, 100);
			dataModel.add(htLogo);
			
			vueLogo.setHost(htLogo);   
			
			graphView.setEditable(true);
			graphView.setRectEditableFunc(function(data){
				return data === vueLogo;
			});
			graphView.setRotationEditableFunc(function(data){
				return data === htLogo;
			});
			
			var eventType = ht.Default.isTouchable ? 'touchend' : 'mouseup';
			graphView.getView().addEventListener(eventType, function(e){
				var data = graphView.getDataAt(e);
				if(data && ht.Default.isDoubleClick(e)){
					alert(data.getName() + ' is double clicked.');
				}
			});
		}
	}
}
</script>

<style lang="scss" scoped>
h1 {
	color: #2c3e50;
}
h2{
	color: #666;
}

.ht-view{
	width: 800px;
	height: 580px;
	margin: auto;
	border: 1px solid #ccc;
}
</style>
